import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

export function CouponRowActions({ coupon }) {
  const history = useHistory();

  const goToDetails = () => {
    history.push({
      pathname: `/payments/coupons/${coupon.id}`,
      state: { coupon },
    });
  };

  const goToEdit = () => {
    history.push({
      pathname: `/payments/coupons/${coupon.id}/edit`,
      state: { coupon },
    });
  };

  return (
    <Dropdown alignRight>
      <Dropdown.Toggle
        bsPrefix="coupon-actions-toggle"
        variant="link"
        className="btn btn-light btn-icon btn-sm"
        id={`coupon-actions-${coupon.id}`}
      >
        <i className="ki ki-bold-more-ver"></i>
      </Dropdown.Toggle>
      <Dropdown.Menu className="dropdown-menu-sm">
        <Dropdown.Item onClick={goToDetails} style={{ whiteSpace: 'normal' }}>
          Visualizar cupom
        </Dropdown.Item>
        <Dropdown.Item onClick={goToEdit} style={{ whiteSpace: 'normal' }}>
          Editar cupom
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}
